import { HttpParams } from '@angular/common/http';
import { Pageable } from 'src/app/core/models/pageable';

export class Utils {
	static removeSeparators(value: string): number {
		if (!(value || parseInt(value.toString()) === 0)) {
			return 0;
		}
		value = value.replace(/'/g, "").replace(/,/g, "");
		if (!value || isNaN(parseInt(value.toString()))) return 0;
		return parseInt(value.toString());
	}

	static createCustomPageableParams(page: Pageable, httpParams: HttpParams, ...defaultSortFields: string[]): HttpParams {
		if (defaultSortFields.length == 0)
			defaultSortFields.push('id')

		if (page.unpaged) {
			httpParams = httpParams.set('unpaged', 'true');
		} else {
			httpParams = httpParams.set('page', page.page.toString());
			httpParams = httpParams.set('size', page.size.toString());
		}

		page.sort?.forEach((sortItem) => {
			if (sortItem.field) {
				httpParams = httpParams.append(
					'sort',
					`${sortItem.field},${sortItem.order}`
				);
			}
		});

		defaultSortFields.forEach(defaultSortField => {
			if (page.sort?.map(sortItem => sortItem.field).indexOf(defaultSortField) == -1) {
				httpParams = httpParams.append(
					'sort',
					`${defaultSortField},asc`
				);
			}
		})

		return httpParams;
	}

	static base64ToBlob(base64: string, contentType = 'image/jpeg'): Blob {
		const byteCharacters = atob(base64); // decode base64 to raw binary
		const byteNumbers = new Array(byteCharacters.length);

		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);
		return new Blob([byteArray], { type: contentType });
	}
}